import { theme } from 'containers/GlobalStyle'
import useTranslations from 'hooks/useTranslations'
import { useFilter } from 'modules/productDetail'
import React from 'react'
import styled from 'styled-components'
import ProductImage from 'theme/atoms/ProductImage'

export default function ColorFilter() {
  const t = useTranslations<'templates-PDP'>()
  const filter = useFilter('color')
  const options = filter.data.options
  if (options.length <= 1) return null

  return (
    <Wrapper data-cy-collection="ColorFilter">
      <h3 className="label">{t('color_label')}</h3>
      <ul className="color-grid">
        {options.map((opt) => (
          <li
            className="option-container"
            key={opt.label}
            data-cy-handle="option"
            onClick={() => filter.setValue(opt.label)}
          >
            <ColorOption
              className={'option'}
              $available={opt.selectable}
              $selected={opt.label === filter.data.value}
            >
              <ProductImage img={opt.image} alt={opt.label} size="xs" />
            </ColorOption>
            <div
              className={`color-label ${opt.selectable ? '' : 'not-available'}`}
            >
              {opt.label}
            </div>
          </li>
        ))}
      </ul>
      <span className="divider" />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  > h3 {
    margin: ${theme.spacing('ml')} ${theme.spacing('ml')};
    ${theme.ty('r-base', null, 'r-xl')}
  }
  > .color-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-row-gap: ${theme.spacing('xs')};
    margin: ${theme.spacing('ml')} ${theme.spacing('ml')};
    > li.option-container {
      display: flex;
      flex-direction: row;
      align-items: center;
      cursor: pointer;

      > .color-label {
        ${theme.ty('rc-base')}
        color: ${theme.colors.b0};
        &.not-available {
          color: ${theme.colors.shade.b3};
        }
      }
    }
  }
  > .divider {
    display: block;
    margin-top: 25px;
    margin: ${theme.spacing('ml')} ${theme.spacing('ml')};
    border-bottom: 1px solid ${theme.colors.shade.b5};
  }
`

const ColorOption = styled.div<{ $selected: boolean; $available: boolean }>`
  ${theme.rounding('s')}
  position: relative;
  margin-right: ${theme.spacing('xs')};
  padding: ${theme.spacing('xxs')};

  border: 1px
    ${(p) =>
      (p.$available ? 'solid ' : 'dashed ') +
      (p.$selected ? theme.colors.primary : theme.colors.shade.b5)};
  > img {
    width: 2rem;
    height: 2rem;
  }
`
